module.exports = __webpack_public_path__ + "static/img/20.beba871.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhmnq/20.jpg
// module id = Z9YX
// module chunks = 1